import React from 'react';

export type TabPanelProps = {
    id: string;
    labelledBy: string;
    className?: string;
    hidden?: boolean;
    style?: React.CSSProperties;
    children: React.ReactNode;
};

export default function TabPanel({
    id,
    labelledBy,
    className,
    hidden = false,
    style,
    children,
}: TabPanelProps) {
    return (
        <div
            role="tabpanel"
            id={id}
            aria-labelledby={labelledBy}
            tabIndex={0}
            hidden={hidden}
            className={className}
            style={style}
        >
            {children}
        </div>
    );
}
